export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const LIBRARY_BASE_URL = process.env.REACT_APP_LIBRARY_BASE_URL;
export const CREATOR_BASE_URL = process.env.REACT_APP_CREATOR_BASE_URL;
export const OAUTH_CLIENT_ACCESS_KEY =
  process.env.REACT_APP_OAUTH_CLIENT_ACCESS_KEY;
export const STIP_BASE_URL = process.env.REACT_APP_STIP_BASE_URL;
export const PROCESSING_BASE_URL = process.env.REACT_APP_PROCESSING_BASE_URL;
export const CATEGORY_BASE_URL = process.env.REACT_APP_CATEGORY_BASE_URL;
export const OPTIN_BASE_URL = process.env.REACT_APP_OPTIN_BASE_URL;
export const CPNA_BASE_URL = process.env.REACT_APP_CPNA_BASE_URL;
export const OPTIN_CLIENT_ACCESS_KEY =
  process.env.REACT_APP_OPTIN_CLIENT_ACCESS_KEY;
export const REPORTS_BASE_URL = process.env.REACT_APP_REPORTS_BASE_URL;
export const CATALOG_BASE_URL = process.env.REACT_APP_CATALOG_BASE_URL;
export const AUTHOR_PANEL_BASE_URL =
  process.env.REACT_APP_AUTHOR_PANEL_BASE_URL;
export const AUTHOR_PANEL_CLIENT_ACCESS_KEY =
  process.env.REACT_APP_AUTHOR_PANEL_CLIENT_ACCESS_KEY;
export const NODE_ENV = process.env.NODE_ENV;
export const CADIE_BASE_URL = process.env.REACT_APP_CADIE_BASE_URL;
